import { $, esc, num, puede, sb, pedirTodo, ordenarPor } from './nucleo';

// ---------- stock ----------
//
//  LAS PREGUNTAS DE ESTA PANTALLA (D102):
//
//   · ABRIR: la pestaña Stock **no la abre ningún permiso**: es visible para
//     cualquiera con sesión y `cargarStock()` corre en `entrar()` para todos.
//     Es una pregunta abierta, no una decisión.
//   · LEER: sin `stock.ver`, `v_stock_disponible` NO devuelve lista vacía sino
//     todos los productos, con los cuatro números en NULL (0055, D132). Un null
//     no es un cero: se pinta un guion con su motivo y nunca pasa por `Number()`.
//
//  Los tres sumandos —físico, comprometido y no vendible— salen de
//  `app.stock_de` (la vista los lee por `app.stock_visible_todos`), calculados
//  como dueño (D132): el número es el mismo para todos. Por eso ya no se
//  muestra un TOPE (`≤ n`): afirmar un tope donde hay una cantidad exacta
//  tampoco dice lo que se sabe (D97, pendiente 65).
//
//  EL TERCER SUMANDO (0055, C4): equipos en el depósito marcados como no
//  vendibles (con falla, caja dañada, en reparación). Cuentan en el físico y no
//  en el disponible; sin su columna la tabla parecía mal sumada.
let STOCK: any[] = [];
//  Tres estados, no dos (D103): `'inicial'` es "todavía no contestó"; una
//  tabla vacía se lee igual que "no hay nada".
let ESTADO: 'inicial' | 'ok' | 'error' = 'inicial', E_STOCK = '';

export async function cargarStock(){
  //  Lo que se ve MIENTRAS TANTO también afirma: la primera respuesta puede
  //  tardar (D92) y no debe decir "no hay stock".
  if (ESTADO === 'inicial')
    $('#tblStock').innerHTML =
      `<tr><td colspan="${COLS}" class="vacio">Leyendo el stock…</td></tr>`;
  const { data, error } = await pedirTodo(() => sb.from('v_stock_disponible').select('*'),
    { por: 'producto_id', orden: ordenarPor('codigo', 'producto_id') });
  E_STOCK = error?.message || '';
  ESTADO  = error ? 'error' : 'ok';
  STOCK   = data || [];
  pintarStock();
}

//  El cartel de esta pantalla: arriba de la tabla, en su propio div.
function carteles(){
  $('#stockMsg').innerHTML = puede('stock','ver') ? ''
    : '<div class="hint"><span class="chip c-bad">no ves las cantidades</span> '
      + 'Te falta el permiso <b>stock.ver</b>. Lo que se ve es el catálogo de productos: '
      + 'el físico y el disponible <b>no son cero, son desconocidos</b>.</div>';
}

//  Las columnas que salen de la base, en el orden de la cuenta: físico −
//  comprometido − no vendible = disponible.
const COLS = 6;

function pintarStock(){
  //  Los carteles SÓLO cuando la tabla muestra el catálogo: con la lectura
  //  caída no hay lista que explicar.
  if (ESTADO !== 'ok'){ $('#stockMsg').innerHTML = ''; }
  else carteles();
  const veCant = puede('stock','ver');
  //  Las cabeceras lo dicen también, por si no se leyó el cartel.
  const rotulo = (t: string) => veCant ? t : `${t} <span class="hint">(?)</span>`;
  $('#thFisico').innerHTML       = rotulo('Físico');
  $('#thComprometido').innerHTML = rotulo('Comprometido');
  $('#thNoVendible').innerHTML   = rotulo('No vendible');
  $('#thDisponible').innerHTML   = rotulo('Disponible');

  const q = ($('#buscaStock').value||'').toLowerCase();
  const f = STOCK.filter(s => !q ||
    (s.codigo||'').toLowerCase().includes(q) || (s.descripcion||'').toLowerCase().includes(q));

  //  Las cinco respuestas de esta tabla, en orden: no contestó · no se pudo
  //  leer · no hay ninguno · nada coincide con el filtro · hay datos.
  if (ESTADO === 'inicial'){
    $('#tblStock').innerHTML =
      `<tr><td colspan="${COLS}" class="vacio">Leyendo el stock…</td></tr>`;
    return;
  }
  if (ESTADO === 'error'){
    //  "No se pudo leer" NUNCA es "no hay nada", ni se deja el stock viejo en pantalla.
    $('#tblStock').innerHTML = `<tr><td colspan="${COLS}" class="vacio">`
      + `No se pudo leer el stock (${esc(E_STOCK)}). No quiere decir que no haya: `
      + `no se pudo preguntar.</td></tr>`;
    return;
  }
  //  Un cero de verdad se escribe; lo que no se sabe va con un guion y su
  //  `title`. LA CELDA DECIDE POR EL VALOR, no por el permiso (D132): nunca
  //  convertir un null en cero con `Number()`.
  const porque = veCant ? 'La base no devolvió este número'
                        : 'Te falta el permiso stock.ver';
  const celda = (n: unknown) => n == null
    ? `<span class="hint" title="${esc(porque)}">—</span>`
    : num(Number(n));

  $('#tblStock').innerHTML = f.map(s=>`
    <tr><td class="mono">${esc(s.codigo)}</td><td>${esc(s.descripcion)}</td>
        <td class="num">${celda(s.fisico)}</td>
        <td class="num">${celda(s.comprometido)}</td>
        <td class="num">${celda(s.no_vendible)}</td>
        <td class="num"><b>${celda(s.disponible)}</b></td></tr>
  `).join('') || `<tr><td colspan="${COLS}" class="vacio">${
    STOCK.length ? 'Nada coincide con ese filtro'
                 //  «activos»: la vista filtra `where p.activo`.
                 : 'Todavía no hay productos activos'}</td></tr>`;
}
$('#buscaStock').oninput = pintarStock;
